import { hanwahaInstance } from '../../../shared_elements';
const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';

export const getChartOfAccount = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getChartOfAccountListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/chart-of-accounts/${queryString ? `?${queryString}` : ''}`;
};

export const getChartOfAccountCompanyNamesApi = () => {
   return `integrations/${qbProvider}/company_name/?source=chart_of_account`;
}